import get from 'lodash-es/get'
import * as React from 'react'

import { shortenNumber } from '../../../../common/utils/formatString'
import { IItemCard } from '../interface'

import * as styles from './lockupSales.module.css'

const LockupSales = ({ item }: IItemCard) => {
  const numSales = get(item, 'number_of_sales', 0)

  if (numSales === 0) {
    return null
  }

  return <div className={styles.root}>{shortenNumber(numSales)} Sales</div>
}

export default LockupSales
